import { createAction, props } from '@ngrx/store';

const GET_PROCESS_HIERARCHY = '[UserStoriesV2] Get Process Hierarchy';
const SET_PROCESS_HIERARCHY = '[UserStoriesV2] Set Process Hierarchy';
const CREATE_PROCESS = '[UserStoriesV2] Create Process';
const ADD_PROCESS_TO_HIERARCHY = '[UserStoriesV2] Add Process to Hierarchy';
const UPDATE_PROCESS = '[UserStoriesV2] Update Process';
const UPDATE_PROCESS_TO_HIERARCHY = '[UserStoriesV2] Update Process to Hierarchy';
const DELETE_PROCESS = '[UserStoriesV2] Delete Process';
const DELETE_PROCESS_FROM_HIERARCHY = '[UserStoriesV2] Delete Process from Hierarchy';
const GET_USER_STORIES_FOR_PROCESS = '[UserStoriesV2] Get User Stories for Process';
const SET_USER_STORIES_FOR_PROCESS = '[UserStoriesV2] Set User Stories for Process';
const CREATE_USER_STORY = '[UserStoriesV2] Create User Story';
const ADD_USER_STORY_TO_PROCESS = '[UserStoriesV2] Add User Story to Process';
const UPDATE_USER_STORY = '[UserStoriesV2] Update User Story';
const UPDATE_USER_STORY_IN_PROCESS = '[UserStoriesV2] Update User Story in Process';
const DELETE_USER_STORY = '[UserStoriesV2] Delete User Story';
const DELETE_USER_STORY_FROM_PROCESS = '[UserStoriesV2] Delete User Story from Process';
const CREATE_PROCESS_SUCCESS = '[UserStoriesV2] Create Process Success';
const CREATE_PROCESS_FAILURE = '[UserStoriesV2] Create Process Failure';
const CREATE_USER_STORY_SUCCESS = '[UserStoriesV2] Create User Story Success';
const CREATE_USER_STORY_FAILURE = '[UserStoriesV2] Create User Story Failure';

const getProcessHierarchy = createAction(
  GET_PROCESS_HIERARCHY,
  props<{ apiConstants: any; urlPathVariables: { appId: string } }>()
);
const setProcessHierarchy = createAction(SET_PROCESS_HIERARCHY, props<{ processHierarchy: any }>());

const createProcess = createAction(
  CREATE_PROCESS,
  props<{
    apiConstants: any;
    process: any;
  }>()
);

const addProcessToHierarchy = createAction(ADD_PROCESS_TO_HIERARCHY, props<{ process: any }>());

const updateProcess = createAction(
  UPDATE_PROCESS,
  props<{
    apiConstants: any;
    process: any;
  }>()
);

const updateProcessToHierarchy = createAction(UPDATE_PROCESS_TO_HIERARCHY, props<{ process: any }>());

const deleteProcess = createAction(
  DELETE_PROCESS,
  props<{ apiConstants: any; urlPathVariables: { processId: string } }>()
);

const deleteProcessFromHierarchy = createAction(DELETE_PROCESS_FROM_HIERARCHY, props<{ processId: string }>());

const createUserStory = createAction(
  CREATE_USER_STORY,
  props<{
    apiConstants: any;
    userStory: any;
  }>()
);

const getUserStoriesForProcess = createAction(
  GET_USER_STORIES_FOR_PROCESS,
  props<{ apiConstants: any; urlPathVariables: { appId: string; processId: string } }>()
);

const setUserStoriesForProcess = createAction(
  SET_USER_STORIES_FOR_PROCESS,
  props<{ processId: string; userStories: any[] }>()
);

const addUserStoryToProcess = createAction(ADD_USER_STORY_TO_PROCESS, props<{ userStory: any }>());

const updateUserStory = createAction(
  UPDATE_USER_STORY,
  props<{
    apiConstants: any;
    userStory: any;
  }>()
);

const updateUserStoryInProcess = createAction(UPDATE_USER_STORY_IN_PROCESS, props<{ userStory: any }>());

const deleteUserStory = createAction(DELETE_USER_STORY, props<{ apiConstants: any; userStory: any }>());

const deleteUserStoryFromProcess = createAction(DELETE_USER_STORY_FROM_PROCESS, props<{ userStory: any }>());

const createProcessSuccess = createAction(CREATE_PROCESS_SUCCESS);

const createProcessFailure = createAction(CREATE_PROCESS_FAILURE);

const createUserStorySuccess = createAction(CREATE_USER_STORY_SUCCESS, props<{ processId: string }>());

const createUserStoryFailure = createAction(CREATE_USER_STORY_FAILURE);

export const UserStoriesV2Actions = {
  getProcessHierarchy,
  setProcessHierarchy,
  createProcess,
  addProcessToHierarchy,
  updateProcess,
  updateProcessToHierarchy,
  deleteProcess,
  deleteProcessFromHierarchy,
  createUserStory,
  addUserStoryToProcess,
  updateUserStory,
  updateUserStoryInProcess,
  deleteUserStory,
  deleteUserStoryFromProcess,
  getUserStoriesForProcess,
  setUserStoriesForProcess,
  createProcessSuccess,
  createProcessFailure,
  createUserStorySuccess,
  createUserStoryFailure
};
